import { render, staticRenderFns } from "./OrdersFBAModule.vue?vue&type=template&id=211c8612"
import script from "./OrdersFBAModule.vue?vue&type=script&lang=js"
export * from "./OrdersFBAModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports